import { useEffect } from "react";

const removeElms = (selector, shadowRootSelector) => {
  const interval = setInterval(() => {
    try {
      const elm =
        document.querySelector(selector).shadowRoot &&
        document.querySelector(selector).shadowRoot.querySelector(shadowRootSelector);
      if (elm) {
        clearInterval(interval);
        elm.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(interval);
  }, 5000);
};

export const Home = () => {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://www.petfinder.com/assets/widgets/scripts/main-widgets-web.js";
  //   script.async = false;
  //   document.body.appendChild(script);

  //   try {
  //     removeElms("#pet-finder > pet-scroller", ".embeddablePetList-logo");
  //     removeElms("#pet-finder > pet-scroller", ".actionCard");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // });

  return (
    <div>
      <p id="mission-statement">
        At Sheepshead Bay Animal Rescue, we are dedicated to providing a safe and loving home for abandoned, neglected,
        and abused animals in Brooklyn and surrounding areas. We understand that these animals have been through
        difficult circumstances and we are committed to giving them the care and support they need to heal and thrive.
      </p>
      <p>
        Our goal is to find permanent, loving homes for these animals and to educate the community on the importance of
        responsible pet ownership and animal welfare. We believe that every animal deserves to live a happy and healthy
        life, and we are dedicated to making that a reality for every animal in our care. We strive to provide top-notch
        medical care, attention, and love to every animal that comes through our doors.
      </p>
      {/* <div id="pet-finder">
        <pet-scroller
          type="[]"
          age="[]"
          limit="48"
          status="adoptable"
          petlisttitle=""
          organization="NY1570"
          apibase="https://api.petfinder.com"
          petfinderurl="https://www.petfinder.com"
          accesstoken="eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJtd1NmUDQ1SEpPckFSS0RkVGM1M3JGSjNHVTJIdnk0SUxVSGR5Y3NnNGpURzRCVHIzdCIsImp0aSI6ImtsSDhNYjBjTFVxN2dEM0xCRlREMmVoSlU0ekVuVjZEZFE4M0pkbDkiLCJpYXQiOjE2NzA3MTQ0MzAsIm5iZiI6MTY3MDcxNDQzMCwiZXhwIjo0ODI2Mzg4MDMwLCJzdWIiOiI5MTM3NTExIiwic2NvcGVzIjpbXX0.RCbQMid81Brvlm8BTI6nCJqUSIlEz6bsO6GZ006S2FuQHvsYBzmyx_In9V8dhLusXN97D8t-ZwodGTvUj-eFyeLXhP6sIocC5_1q-yE3dEKHgabARwJxSHMhB9Mz_6jifHyD8nK8wBjGhGNMf_FomE7ec5zd9qp1FodysaoGTkyRtJXnMhPYcV7NPYLcMYp-tCv-Vs1cNs6LqquUrdSO6w-G9RB5HLzMP8DcmQjP_66YoE85AeKwvs7Er4PsAfBACWqpelOT7FR4nOLk0mJ-KtoVSaUkxZeRn2J4KIsTR12IIRmsJG_6w1ixmQ4eX2uPBW1Si20ai80i6GdLgdY6rA"
        ></pet-scroller>
      </div> */}
    </div>
  );
};
